import CheckboxDescription from "./CheckboxDescription.vue";

export default CheckboxDescription;
